import { render, staticRenderFns } from "./QuizzComponent.vue?vue&type=template&id=4b2ce527&"
import script from "./QuizzComponent.vue?vue&type=script&lang=js&"
export * from "./QuizzComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports